import { ref } from "vue";
import type { AxiosError } from "axios";

export function useErrorPanel() {
  const errorMessage = ref<string | null>(null);
  const errorTitle = ref("");
  const errorDetails = ref<string>("");

  const clearError = (): void => {
    errorMessage.value = null;
    errorTitle.value = "";
    errorDetails.value = "";
  };

  const setError = (title: string, details: string): void => {
    errorTitle.value = title;
    errorDetails.value = details;
    errorMessage.value = title;
  };

  const extractErrorMessage = (error: unknown): string => {
    if (!error) return "An unknown error occurred";

    const axiosError = error as AxiosError<{ detail?: string }>;
    const errorDetail =
      axiosError?.response?.data?.detail ||
      (error as Record<string, unknown>)?.message;

    if (!errorDetail) {
      return "An unexpected error occurred";
    }

    return String(errorDetail);
  };

  return {
    errorMessage,
    errorTitle,
    errorDetails,
    clearError,
    setError,
    extractErrorMessage,
  };
}
